const s3 = "https://s3.us-east-2.amazonaws.com/s3-stockperks-public.com"

const ImagePathNormalizer = (path?: string) => {
  if (!path) {
    return ""
  }
  if (path.startsWith("http")) {
    return path
  }

  return `${s3}${path}`
}

export default ImagePathNormalizer
